export const SET_USER_ID = "SET_USER_ID";
export const SET_RESULT = "SET_RESULT";
export const SET_NAME = "SET_NAME";